<lm-list
    lm-list-search-form
    [listUrlInfo]="listUrlInfo"
    [listSpec]="listSpec"
    [hasDependentData]="pane?.hasDependentPanels"
    [lmBuildDependentPaneDetail]="LMBuildDependentPaneDetail"
    [fromDataView]="fromDataView"
    [overrideListTitle]="overrideListTitle"
    [listInPagePaneTab]="true"
    [pageHasContextForm]="pageHasContextForm"
    [pageHasTabs]="pageHasTabs"
    [specialActions]="getPaneSpec()?.pane?.actions"

    (listRowSelected)="onListRowSelected($event)"
    (listDisplayed)="onListDisplayed($event)"
    (listRowActivated)="onListRowActivated($event)"
    (listRowDeactivated)="onListRowDeactivated($event)"
    (updateToolbarStateEvent)="onUpdateToolbarStateEvent($event)"
    (sendContextMessageEvent)="onSendContextMessageEvent($event)"
    (contentModified)="onContentModified($event)"
    (listTransactionEvent)="onPanelDataUpdated($event)"
></lm-list>
